// ===== Revisão =====
function renderRevisaoOrcamento(){
  const el=document.getElementById('orc-revisao-container');if(!el)return;
  const g=id=>document.getElementById(id)?.value||'';
  const cliente=g('p-cliente'),tel=g('p-tel'),email=g('p-email');
  const ambientes=nomesAmbientesAtuais();
  const valorTotal=parseMoneyInput(document.getElementById('p-valor'));
  const pagamentosSoma=(_pedPagamentos||[]).reduce((s,r)=>s+(parseFloat(r.valor)||0),0);
  const checks=[];
  const push=(tipo,texto,ok,focoId)=>checks.push({tipo,texto,ok,focoId});
  push('impeditivo','Cliente identificado',!!cliente.trim(),'p-cliente');
  push('alerta','Telefone ou e-mail informado',!!(tel.trim()||email.trim()),'p-tel');
  push('impeditivo','Endereço da obra preenchido',!!g('p-end').trim(),'p-end');
  push('impeditivo','Existe pelo menos um ambiente',ambientes.length>0,null);
  push('impeditivo','Todos os ambientes possuem peças',ambientes.every(a=>pecasDoAmbiente(a).length>0),null);
  push('impeditivo','Todas as peças possuem descrição',_pedItens.every(it=>!!String(it.desc||'').trim()),null);
  push('impeditivo','Material não informado em alguma peça',_pedItens.every(it=>!!String(it.material||'').trim()),null);
  push('impeditivo','Dimensão inválida em alguma peça',_pedItens.every(it=>parseFloat(it.comp)>0&&parseFloat(it.larg)>0),null);
  push('impeditivo','Todas as peças possuem quantidade válida',_pedItens.every(it=>parseFloat(it.qtd)>0),null);
  push('impeditivo','Não existem valores inválidos (NaN)',!_pedItens.some(it=>[it.comp,it.larg,it.qtd].some(v=>v!==''&&v!=null&&isNaN(parseFloat(v)))),null);
  push('impeditivo','Não existem valores negativos',!_pedItens.some(it=>[it.comp,it.larg,it.qtd,it.mo].some(v=>parseFloat(v)<0)),null);
  push('alerta','Acabamentos definidos em todas as peças',_pedItens.every(it=>!!it.acabamento),null);
  push('alerta','Bordas definidas em todas as peças',_pedItens.every(it=>!!it.borda),null);
  push('alerta','Status da medição informado em todas as peças',_pedItens.every(it=>!!it.statusMedida),null);
  const origemPrestador=g('p-origem')==='Indicação de prestador';
  push('alerta','Comissão sem profissional vinculado',!origemPrestador||!!document.getElementById('p-indicador-id')?.value,'p-indicador-id');
  push('impeditivo','Plano de pagamento fecha o total',!pagamentosSoma||Math.abs(pagamentosSoma-valorTotal)<0.05,null);
  push('alerta','Documento de referência não informado',!!g('p-documento-base').trim(),'p-documento-base');
  push('concluido','Medição técnica aprovada',_pedItens.length>0&&_pedItens.every(it=>it.statusMedida==='aprovada'),null);
  push('concluido','Todos os materiais selecionados',_pedItens.length>0&&_pedItens.every(it=>!!String(it.material||'').trim()),null);

  const impeditivos=checks.filter(c=>c.tipo==='impeditivo'&&!c.ok);
  const alertas=checks.filter(c=>c.tipo==='alerta'&&!c.ok);
  _pedRevisaoTemImpeditivo=impeditivos.length>0;

  const resumoTopo=`<div style="display:flex;gap:10px;margin-bottom:16px;flex-wrap:wrap">
    ${impeditivos.length?`<span class="badge" style="background:color-mix(in srgb,var(--red) 18%,transparent);color:var(--red)">${impeditivos.length} pendência(s) impedem o envio</span>`:'<span class="badge" style="background:color-mix(in srgb,var(--green) 18%,transparent);color:var(--green)">Sem pendências impeditivas</span>'}
    ${alertas.length?`<span class="badge" style="background:color-mix(in srgb,var(--warn) 18%,transparent);color:var(--warn)">${alertas.length} alerta(s) precisam de atenção</span>`:''}
  </div>`;
  const listaChecklist=checks.map(c=>{
    const classe=c.ok?'concluido':c.tipo;
    const icone=c.ok?'✓':(c.tipo==='impeditivo'?'✕':'⚠');
    return `<div class="orc-checklist-item ${classe}"${c.focoId?` onclick="switchOrcTab(0);setTimeout(()=>document.getElementById('${c.focoId}')?.focus(),50)"`:''}>${icone} ${escapeHtml(c.texto)}</div>`;
  }).join('');
  const resumoAmbientes=ambientes.map(a=>{
    const pecas=pecasDoAmbiente(a);
    const total=pecas.reduce((s,x)=>s+(x.it._subtotal||0),0);
    return `<div style="margin-bottom:10px"><strong>${escapeHtml(a)}</strong> — ${pecas.length} peça(s) · ${fmt(total)}
      <div style="font-size:11.5px;color:var(--muted);margin-top:2px">${pecas.map(x=>escapeHtml(x.it.desc||'Peça')+' ('+escapeHtml(x.it.material||'—')+')').join(', ')||'—'}</div>
    </div>`;
  }).join('')||'<div style="color:var(--muted);font-size:12px">Nenhum ambiente cadastrado.</div>';

  el.innerHTML=`
    ${resumoTopo}
    <div class="section-divider">Resumo</div>
    <div style="font-size:12.5px;line-height:1.7;margin-bottom:14px">
      <strong>${escapeHtml(cliente||'Cliente não informado')}</strong> · ${escapeHtml(tel||email||'sem contato')}<br>
      ${escapeHtml(g('p-end'))||'Endereço não informado'}<br>
      Origem técnica: ${escapeHtml(BASES_ORCAMENTO[g('p-base-orcamento')]?.label||'não informada')}
    </div>
    <div class="section-divider">Ambientes e peças</div>
    ${resumoAmbientes}
    <div class="section-divider">Descrição do serviço</div>
    <div style="font-size:12.5px;white-space:pre-wrap;margin-bottom:14px">${escapeHtml(g('p-desc'))||'—'}</div>
    <div class="section-divider">Financeiro</div>
    <div style="font-size:12.5px;margin-bottom:14px">Valor total: <strong>${fmt(valorTotal)}</strong>${pagamentosSoma?` · Plano de pagamento soma ${fmt(pagamentosSoma)}`:''}</div>
    <div class="section-divider">Checklist de validação</div>
    ${listaChecklist}
  `;
}

